<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Education level' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Code' | translate}}</label>
      <input class="form-control" [(ngModel)]="entity.code" />
    </div>

    <div class="form-group">
      <label>{{'Title' | translate}}</label>
      <input class="form-control" [(ngModel)]="entity.title" />
    </div>

    <div class="form-group">
      <label>{{'International title' | translate}}</label>
      <input class="form-control" [(ngModel)]="entity.internationalTitle" />
    </div>

    <div class="form-group">
      <label>{{'School' | translate}}</label>
      <select class="form-control" [(ngModel)]="entity.schoolId">
        <option [value]="option.id" *ngFor="let option of schoolData">{{option.name}}</option>
      </select>
    </div>

    <div class="form-group">
      <label>{{'Education level' | translate}}</label>
      <select class="form-control" [(ngModel)]="entity.educationLevelId">
        <option [value]="option.id" *ngFor="let option of educationLevelData">{{option.name}}</option>
      </select>
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>

